import { useIsSettingsContextMutating } from "@/entities/settings";
import {
  useOrganizationContext,
  useOrganizationContextDetail,
  useOrganizationContextList,
} from "@/modules/organization/organization-context";

export const useOrganizationContextLoader = () => {
  const { isLoading } = useOrganizationContext();
  const { isLoading: isListLoading } = useOrganizationContextList();
  const { isLoading: isDetailLoading } = useOrganizationContextDetail();
  const isMutating = useIsSettingsContextMutating();

  return isLoading || isListLoading || isDetailLoading || isMutating;
};
